<template>
  <div style="margin: 0 auto; margin-bottom: 10px; height: 100%" class="mobileAd" v-show="isShow">
    <div v-if="isShowGoogle">
      <AdGoogleVue v-if="!onlyMobile" class="pc" :wid="google_pc_wid" :hgt="google_pc_hgt"></AdGoogleVue>
      <AdGoogleVue class="mobile" :wid="google_mobile_wid" :hgt="google_mobile_hgt"></AdGoogleVue>
    </div>
    <div v-else style="height: 100%">
      <AdBaseimgVue :pcObj="pageData" :mobileObj="mobileData" :onlyMobile="onlyMobile" :isShowColse="isShowColse"
        @colse="$emit('colse')" @ck="ck"></AdBaseimgVue>
    </div>
  </div>
</template>

<script>
import AdBaseimgVue from "./AdBaseimg.vue";
import AdGoogleVue from "./AdGoogle.vue";

export default {
  components: {
    AdBaseimgVue,
    AdGoogleVue,
  },
  props: {
    tp: { Type: String, required: true },
    google_pc_wid: { Type: String, default: "300px" },
    google_pc_hgt: { Type: String, default: "250px" },
    google_mobile_wid: { Type: String, default: "100%" },
    google_mobile_hgt: { Type: String, default: "25%" },
    onlyMobile: { type: Boolean, default: false },
    isShowColse: { type: Boolean, default: false },
  },
  data() {
    return {
      isShowGoogle: false,
      pageData: null,
      mobileData: null,
      isShow: false,
    };
  },
  created() {
    this.getAdInfo();
  },
  methods: {
    ck(id) {
      let params = {
        id,
      };
      this.$api.BannerApi.BannerCk(params).then((data) => { });
    },
    getRandom(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    async getAdInfo() {
      let params = {
        SGL_Type: this.tp,
      };
      if (this.checkIsMobile()) {
        console.log("show mobile ad");
        params = {
          SGL_Type: this.tp + "_M",
        };
        let res = await this.$api.BannerApi.getBanner(params);
        if (res.data.success) {
          if (res.data.result.items.length > 0) {
            this.mobileData =
              res.data.result.items[
              this.getRandom(0, res.data.result.items.length)
              ];
            if (this.mobileData) {
              this.mobileData.sgL_ImageClickUrl = this.urlHttpCheck(
                this.mobileData.sgL_ImageClickUrl
              );
            }
          }
        } else {
          console.error(res.data.error.message);
        }
      } else {
        // console.log("show PC ad");
        let res = await this.$api.BannerApi.getBanner(params);
        if (res.data.success) {
          if (res.data.result.items.length > 0) {
            this.pageData =
              res.data.result.items[
              this.getRandom(0, res.data.result.items.length)
              ];
            if (this.pageData) {
              this.pageData.sgL_ImageClickUrl = this.urlHttpCheck(
                this.pageData.sgL_ImageClickUrl
              );
            }
          }
        }
      }
      if (!this.pageData && !this.mobileData) {
        this.isShowGoogle = true;
      }
      this.isShow = true;
    },
  },
};
</script>

<style scoped>
.pc {
  display: block !important;
}

.mobile {
  display: none !important;
}

@media (max-width: 575px) {
  .pc {
    display: none !important;
  }

  .mobileAd {
    display: none !important;
  }

  .mobile {
    display: block !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Ad/AdBase.vue